package com.yendo.mx.models

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class AlgoliaResponse(
    val hits: List<JsonObject> = emptyList()
)
